"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _upload = _interopRequireDefault(require("@/components/uploadImg/upload.vue"));
var _index = require("@/api/appBasicSetup/index.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LabelConfiguration',
  components: {
    upload: _upload.default
  },
  data: function data() {
    return {
      form1: {
        imgUrl: '',
        bgColor: '',
        textColor: ''
      },
      form2: {
        imgUrl: '',
        bgColor: '',
        textColor: ''
      },
      form3: {
        imgUrl: '',
        bgColor: '',
        textColor: ''
      },
      rules: {
        imgUrl: [{
          required: true,
          message: '请上传左侧图标',
          trigger: 'change'
        }],
        bgColor: [{
          required: true,
          message: '请输入右侧金额背景色',
          trigger: 'change'
        }],
        textColor: [{
          required: true,
          message: '请输入右侧金额文字色',
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;
      (0, _index.homeGoodsListConfigQuery)().then(function (res) {
        var _ref = res.data || {},
          rebateData = _ref.rebateData,
          couponData = _ref.couponData,
          upgradeData = _ref.upgradeData;
        if (rebateData) {
          _this.form1.imgUrl = rebateData.rebatePic || '';
          _this.form1.bgColor = rebateData.rightBackgroundColor || '';
          _this.form1.textColor = rebateData.rightTextColor || '';
        }
        if (upgradeData) {
          _this.form2.imgUrl = upgradeData.upgradePic || '';
          _this.form2.bgColor = upgradeData.rightBackgroundColor || '';
          _this.form2.textColor = upgradeData.rightTextColor || '';
        }
        if (couponData) {
          _this.form3.imgUrl = couponData.couponPic || '';
          _this.form3.bgColor = couponData.rightBackgroundColor || '';
          _this.form3.textColor = couponData.rightTextColor || '';
        }
      });
    },
    onPictureAddress: function onPictureAddress(data, formKey) {
      this[formKey].imgUrl = data.pictureUrl;
      this.$refs[formKey].validateField('imgUrl');
    },
    handleSubmit: function handleSubmit(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认保存当前配置？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            var payload = {
              userId: _this2.userId,
              appId: _this2.appId
            };
            var formData = _this2[formName];
            if (formName === 'form1') {
              payload.rebateData = {
                rebatePic: formData.imgUrl,
                rightBackgroundColor: formData.bgColor,
                rightTextColor: formData.textColor
              };
            } else if (formName === 'form2') {
              payload.upgradeData = {
                upgradePic: formData.imgUrl,
                rightBackgroundColor: formData.bgColor,
                rightTextColor: formData.textColor
              };
            } else if (formName === 'form3') {
              payload.couponData = {
                couponPic: formData.imgUrl,
                rightBackgroundColor: formData.bgColor,
                rightTextColor: formData.textColor
              };
            }
            (0, _index.homeGoodsListConfigSettings)(payload).then(function () {
              _this2.$notify.success({
                title: '温馨提示',
                message: '保存成功！'
              });
              _this2.fetchData();
            });
          });
        } else {
          return false;
        }
      });
    },
    handleReset: function handleReset(formName) {
      this[formName] = {
        imgUrl: '',
        bgColor: '',
        textColor: ''
      };
      this.$refs[formName].clearValidate();
    }
  }
};